import { AuthxClientApiFp, Configuration } from '@jibo-cloud/authx-client'
import axios from 'axios'

const authx = AuthxClientApiFp(new Configuration({ basePath: process.env.JIBO_SERVICES_AUTHX }))

export const loginService = async (credentials: { username: string; password: string }) =>
  (await (await authx.authLogin(credentials))(axios.create())).data

export const refreshService = async (refreshToken: string) =>
  (await (await authx.authRefresh({ refreshToken }))(axios.create())).data
